import { PlaygroundLocalMsg } from "@faire/prototype-playground/platform/localization";
import type { ReactNode } from "react";

import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";
import { cn } from "../../../lib/utils";

import { MORE_IDEAS_SECTION_ID } from "./moreIdeas";

interface MoreIdeasSectionProps {
  products: FaireProductEntity[];
  renderTile: (product: FaireProductEntity) => ReactNode;
  /** One fewer column at desktop, for when the side cart narrows the page. */
  compact?: boolean;
}

/** "More ideas you might like" recommendations grid; the FAB scrolls here. */
export const MoreIdeasSection = ({
  products,
  renderTile,
  compact = false,
}: MoreIdeasSectionProps) => {
  if (products.length === 0) {
    return null;
  }
  return (
    <section
      id={MORE_IDEAS_SECTION_ID}
      className="flex scroll-mt-4 flex-col gap-4"
    >
      <h2 className="type-fs-subheading-medium text-fs-text-primary">
        <PlaygroundLocalMsg defaultMessage="More ideas you might like" />
      </h2>
      <div
        className={cn(
          "grid grid-cols-2 gap-4 md:grid-cols-4",
          compact ? "lg:grid-cols-5" : "lg:grid-cols-6"
        )}
      >
        {products.map(renderTile)}
      </div>
    </section>
  );
};
